import React from 'react';
import { Language } from '@/i18n/languages';
import { generateMetadata } from '@/utils/metadata';
import { sectionsRefer } from '@/enums/sectionsRefer';
import loadNamespaces from 'next-translate/loadNamespaces';
import { GetStaticPropsContext, GetStaticPropsResult } from 'next';

import { Animation } from '@starsoft/common/components';
import HomeAboutUs from '@/components/Home/AboutUs';
import HomeAreas from '@/components/Home/Areas';
import HomeGamesSections from '@/components/Home/Games';
import HomeHero from '@/components/Home/Hero';
import HomePaymentProviders from '@/components/Home/PaymentProviders';
import HomeProviders from '@/components/Home/Providers';
import HomeSolutions from '@/components/Home/Solutions';
import WorkWithUsSection from '@/components/Home/WorkWithUs';

export default function Home() {
  return (
    <React.Fragment>
      <HomeHero />
      <Animation type="fadeInUp" triggerOnce>
        <HomeSolutions />
      </Animation>
      <Animation type="fadeInLeft" triggerOnce>
        <HomeAreas />
      </Animation>
      <Animation type="fadeInUp" triggerOnce>
        <HomeAboutUs />
      </Animation>
      <div id={sectionsRefer.providers}>
        <HomeProviders />
      </div>
      <Animation type="fadeInUp" triggerOnce>
        <HomeGamesSections />
      </Animation>
      <Animation type="fadeInLeft" triggerOnce>
        <HomePaymentProviders />
      </Animation>
      <WorkWithUsSection />
    </React.Fragment>
  );
}

export async function getStaticProps({
  locale,
}: GetStaticPropsContext): Promise<GetStaticPropsResult<{ metadata: string }>> {
  const metadata = await generateMetadata({
    lang: locale as Language,
    path: '/',
    description: 'home_description',
    follow: true,
    title: 'home_heading',
  });

  return {
    props: {
      metadata: JSON.stringify(metadata),
      ...(await loadNamespaces({
        locale,
        pathname: '/',
        nsSeparator: ':',
        keySeparator: '.',
      })),
    },
  };
}
